import { CampaignTypes } from 'features/Codes'

export const CONVERSION_TRACKING_REQUIRED_MESSAGE =
  '톡채널검색 캠페인은 전환추적 설정이 필수입니다.'

// 톡채널검색 캠페인은 전환추적(픽셀&SDK) 연동이 필수이다.
// 미선택(conversionTrackingId === null, "연동하지 않기") 상태면 오류 문구를, 아니면 false 를 반환한다.
export const getConversionTrackingError = (
  campaignType,
  conversionTrackingId
) =>
  campaignType === CampaignTypes.TALK_CHANNEL && conversionTrackingId === null
    ? CONVERSION_TRACKING_REQUIRED_MESSAGE
    : false
